import { Directive, NgZone, OnDestroy, OnInit, Host } from '@angular/core';
import { ScrollBarService } from './scrollbar.service';
import { NgScrollbar } from 'ngx-scrollbar';

@Directive({
    selector: '[scrollbarRef]',
    standalone: true
})
export class ScrollbarRefDirective implements OnInit, OnDestroy {

  constructor(
    @Host() private scrollBarRef: NgScrollbar,
    protected scrollBarService: ScrollBarService,
    protected ngZone: NgZone
    ) { }

  ngOnInit(): void {
    this.scrollBarService.register(this.scrollBarRef);
  }

  ngOnDestroy(): void {
    this.scrollBarService.deregister(this.scrollBarRef);
  }

}
